module.exports = __webpack_public_path__ + "img/visa-mc.42b0802d.png";